import { ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { TextField } from '@mui/material'
import type { OrganisationDTO } from '@api/fastAPI.schemas'
import { TextField as FormTextField } from '@ui/forms'
import IsAdminCheckboxField from '../../../IsAdminCheckboxField'
import OrganisationAutocompleteField from '../../../OrganisationAutocompleteField'
import type { FormValues } from '../../types'

interface UserFieldsProps {
  organisations: OrganisationDTO[]
}

const UserFields = ({ organisations }: UserFieldsProps): ReactElement | null => {
  const { control, watch } = useFormContext<FormValues>()
  const selectedUser = watch('selectedUser')
  const {
    field: { value: organisationValue, onChange: onOrganisationChange },
    fieldState: { error: organisationError },
  } = useController({ name: 'organisation', control })
  const {
    field: { value: isAdminValue, onChange: onIsAdminChange },
  } = useController({ name: 'isAdmin', control })

  if (!selectedUser) return null

  return (
    <>
      <FormTextField name="name" label="Name" data-cy="input-user-name" />
      <TextField label="E-Mail" size="small" value={selectedUser.email || ''} disabled />
      <OrganisationAutocompleteField
        organisations={organisations}
        value={organisationValue}
        onChange={onOrganisationChange}
        dataCy="select-user-organisation"
        // The organisation is mandatory, so an empty list is a dead end -- and
        // this dialog cannot create one.
        noOptionsText="Keine Organisation vorhanden – zuerst im Tab „Organisationen“ anlegen"
        error={organisationError?.message}
      />
      <IsAdminCheckboxField
        value={isAdminValue}
        onChange={onIsAdminChange}
        label="Administrator dieser Organisation"
        dataCy="checkbox-user-is-admin"
      />
    </>
  )
}

export default UserFields
